import React from 'react';
import IntroducedCafesTable from './introducedCafesTable';
import IntroducedCafesFilter from './introducedCafesFilter';
import Pagination2 from '../../components/Pagination2';
import * as introducedCafesActions from '../../redux/introducedCafes/actions';
import { connect } from 'react-redux';
import Spin from '../../components/loading';
import submitForm from '../../utils/submitForm';
import AlertAndConfirmation from '../../utils/AlertAndConfirmation';

class IntroducedCafes extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      errorText: locales('errors.default'),
      errorFlag: false,
      itemsPerPage: 10,
      sortType: 'asc',
      sortBy: 'createdAt'
    };
  }
  componentDidMount() {
    this.sortTable(this.state.sortBy);
  }

  handleAlert = () => {
    AlertAndConfirmation({ text: this.state.errorText, type: 'error' });
    this.setState({ errorFlag: false });
  };

  buildSearchQuery = (pageNumber, pageSize) => {
    if (!isNaN(pageNumber) && !isNaN(pageSize)) {
      let query = `pageNumber=${pageNumber}&pageSize=${pageSize}`;
      query += `&${this.state.query || 'sort=createdAt-desc'}`;
      return query;
    }
  };

  onPageChanged = data => {
    const { currentPage, totalPages, pageLimit } = data;
    this.setState({ currentPage: currentPage }, () => {
      const query = this.buildSearchQuery(this.state.currentPage, this.state.itemsPerPage);
      this.props.fetchAllIntroducedCafes(query);
    });
  };

  filterAndSort = () => {
    let { filter, sort } = this.state;
    let query;
    if (sort && filter) query = `${filter}&${sort}`;
    else if (filter) query = `${filter}`;
    else if (sort) query = `${sort}`;
    this.setState({ query, currentPage: 1 }, () => {
      let searchQuery = this.buildSearchQuery(this.state.currentPage, this.state.itemsPerPage);
      this.props.fetchAllIntroducedCafes(searchQuery);
    });
  };
  sortTable = query => {
    this.setState({ sortType: this.state.sortType == 'asc' ? 'desc' : 'asc' }, () => {
      query = `${query}-${this.state.sortType}`;
      this.setState({ sort: `sort=${query}` }, () => this.filterAndSort());
    });
  };

  applyFilters = event => {
    const queryString = submitForm(event, this.state.selectedRegions, this.state.selectedAmenities);
    this.setState({ filter: queryString }, () => this.filterAndSort());
  };
  render() {
    let { loading, message, failed, error, introducedCafesList } = this.props;
    let { totalRecords } = this.props.introducedCafes;
    let { currentPage, itemsPerPage, sortType } = this.state;
    return (
      <>
        {this.state.errorFlag && this.handleAlert()}
        <section className="p-1 col-12">
          <h3 className="text-muted py-4">
            <div className="text-right">{locales('titles.introducedCafes')}</div>
          </h3>
          {/* <div className='col-12 d-flex justify-content-center align-items-center h-100'> */}
          <Spin spinning={loading}>
            <article>
              <main className="panel panel-default">
                {error ? (
                  <div className="alert alert-danger">{locales('messages.server.error')}</div>
                ) : (
                  <>
                    {failed && <div className="alert alert-danger">{message}</div>}
                    <div className="panel-heading">
                      <i className="fas fa-list-alt px-1" />
                      {locales('titles.introducedCafesLit')}
                    </div>
                    <div className="panel-body">
                      <IntroducedCafesFilter
                        applyFilters={this.applyFilters}
                        filterAndSort={this.filterAndSort}
                      />
                      <IntroducedCafesTable
                        pageNumber={currentPage}
                        pageSize={itemsPerPage}
                        sortType={sortType}
                        sortTable={this.sortTable}
                      />
                      <footer className="col-12 d-flex justify-content-center py-2">
                        <div className="pagination-container">
                          <Pagination2
                            totalRecords={totalRecords || 0}
                            pageLimit={itemsPerPage}
                            pageNeighbours={2}
                            onPageChanged={this.onPageChanged}
                            currentPage={this.state.currentPage}
                          />
                        </div>
                      </footer>
                    </div>
                  </>
                )}
              </main>
            </article>
          </Spin>
        </section>
      </>
    );
  }
}
const mapStateToProps = state => {
  return {
    loading: state.introducedCafesReducer.introducedCafesLoading,
    message: state.introducedCafesReducer.introducedCafesMessage,
    failed: state.introducedCafesReducer.introducedCafesFailed,
    error: state.introducedCafesReducer.introducedCafesError,
    introducedCafes: state.introducedCafesReducer.introducedCafes,
    introducedCafesList: state.introducedCafesReducer.introducedCafesList
  };
};
const mapDispatchToProps = dispatch => {
  return {
    fetchAllIntroducedCafes: query => dispatch(introducedCafesActions.fetchAllIntroducedCafes(query))
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(IntroducedCafes);
